export const BulkOperationState = Object.freeze({
	waitingForFiles: 'waiting-for-files',
	waitingForOperation: 'waiting-for-operation',
	userInput: 'user-input',
	uploading: 'uploading',
	completed: 'completed',
	cancelled: 'cancelled',
	operating: 'operating'
});
